import { BooleanInput } from '@angular/cdk/coercion';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  InputSignal,
  InputSignalWithTransform,
  ViewEncapsulation
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[tiime-button], a[tiime-button]',
  /* eslint-disable  @typescript-eslint/naming-convention*/
  host: {
    '[class.primary]': 'color() === "primary"',
    '[class.accent]': 'color() === "accent"',
    '[class.warn]': 'color() === "warn"',
    '[class.strocked]': 'strocked()',
    '[class.raised]': 'raised()',
    '[class.large]': 'large()',
    '[class.small]': 'small()',
    '[class.icon]': 'icon()',
    class: 'tiime-button'
  },
  /* eslint-enable @typescript-eslint/naming-convention*/
  templateUrl: './button.component.html',
  styleUrls: ['button.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  readonly color: InputSignal<ThemePalette> = input<ThemePalette>();
  readonly strocked: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly raised: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly small: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly large: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });
  readonly icon: InputSignalWithTransform<boolean, BooleanInput> = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute
  });

  constructor(public elementRef: ElementRef) {}
}
